import { Phone } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/oz-property-logo.webp";
import { PHONE_DISPLAY, PHONE_HREF } from "@/components/Header";

const footerLinks = {
  Services: [
    { label: "Interior Upgrades", href: "/services" },
    { label: "Outdoor Improvements", href: "/services" },
    { label: "Property Maintenance", href: "/services" },
    { label: "Security & Access", href: "/services" },
    { label: "Renovation Support", href: "/services" },
    { label: "Commercial Services", href: "/services" },
  ],
  Packages: [
    { label: "Media Wall Package", href: "/packages" },
    { label: "Backyard Makeover Package", href: "/packages" },
    { label: "Rental Refresh Package", href: "/packages" },
    { label: "Pre-Sale Upgrade Package", href: "/packages" },
    { label: "Home Security Package", href: "/packages" },
    { label: "Commercial Maintenance Package", href: "/packages" },
  ],
  Locations: [
    { label: "Broadmeadows", href: "/service-areas" },
    { label: "Craigieburn", href: "/service-areas" },
    { label: "Glenroy", href: "/service-areas" },
    { label: "Fawkner", href: "/service-areas" },
    { label: "Coburg", href: "/service-areas" },
    { label: "Melbourne", href: "/service-areas" },
  ],
  Company: [
    { label: "About", href: "/about" },
    { label: "Our Work", href: "/our-work" },
    { label: "Get a Quote", href: "/get-quote" },
    { label: "Contact", href: "/contact" },
  ],
  Legal: [
    { label: "Privacy Policy", href: "#" },
    { label: "Terms & Conditions", href: "#" },
  ],
};

const Footer = () => (
  <footer className="bg-[#111111] pt-14 pb-8">
    <div className="container">
      {/* Top row - logo, tagline, phone */}
      <div className="mb-10">
        <img src={logo} alt="Oz Property Services Co." className="h-24 md:h-28 w-auto mb-3" width="1536" height="1024" />
        <p className="text-[#FFC300] font-bold text-base">Property maintenance, upgrades and renovation support across Melbourne.</p>
        <p className="text-white/60 text-xs mt-1.5">Residential &amp; commercial&nbsp;•&nbsp;Fast response</p>

        <div className="mt-5">
          <p className="text-white/65 text-[11px] uppercase tracking-wider font-semibold mb-1.5">Call us</p>
          <a
            href={PHONE_HREF}
            className="flex items-center gap-2 text-[#FFC300] font-bold text-xl hover:opacity-80 transition-opacity w-fit"
          >
            <Phone className="w-5 h-5" />
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>

      {/* Link columns */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-8 mb-10">
        {Object.entries(footerLinks).map(([heading, links]) => (
          <div key={heading}>
            <p className="font-bold text-white text-sm mb-3.5">{heading}</p>
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link.label}>
                  {link.href.startsWith("/") ? (
                    <Link
                      to={link.href}
                      className="text-white/45 text-sm hover:text-white/70 transition-colors"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-white/45 text-sm hover:text-white/70 transition-colors"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Divider + copyright */}
      <div className="border-t border-white/10" />
      <div className="pt-5 text-white/60 text-xs text-center">
        © {new Date().getFullYear()} Oz Property Services Co. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
